import createObjectUrlForFileBlob from '../actions/createObjectUrlForFileBlob';
import InlineImageViewState from '../schema/InlineImageViewState';
import createLogger from '../utils/logger';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import {
    AttachmentFileList,
    AttachmentFileType,
    LocalComputerFile,
} from 'owa-attachment-file-types';
import { IEditor } from 'roosterjs-editor-types';

export function createAndSetImageInEditor(editor: IEditor, imageSrc: string) {
    const img = editor.getDocument().createElement('img');
    img.style.maxWidth = '100%';
    img.src = imageSrc;
    editor.insertNode(img);
}

export default async function insertInlineImages(
    files: AttachmentFileList,
    editorViewState: EditorViewState,
    inlineImageViewState: InlineImageViewState
) {
    const localFiles: LocalComputerFile[] = [];
    const promises: Promise<string>[] = [];
    const logger = createLogger(editorViewState.editorId);

    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.fileType == AttachmentFileType.Local) {
            const localFile = <LocalComputerFile>file;
            localFiles.push(localFile);
            promises.push(getDataUrlFromFile(localFile.fileObject));
        }
    }

    if (localFiles.length > 0) {
        const dataUris = await Promise.all(promises);
        const operateContent = await lazyOperateContent.import();
        operateContent(editorViewState, editor => {
            editor.focus();
            editor.addUndoSnapshot(() => {
                localFiles.forEach((file, i) => {
                    const objectUrl = createObjectUrlForFileBlob(
                        inlineImageViewState,
                        file.fileObject,
                        dataUris[i]
                    );
                    createAndSetImageInEditor(editor, objectUrl);
                    file.tempId = objectUrl;
                    logger('newImage', 'insertImage');
                });
            }, 'InsertImage');

            return null;
        });
    }

    return files;
}

function getDataUrlFromFile(file: File): Promise<string> {
    return new Promise<string>(resolve => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result as string);
        };
        reader.readAsDataURL(file);
    });
}
